import { render, staticRenderFns } from "./DeckCardPartner.vue?vue&type=template&id=f6fe07ae"
import script from "./DeckCardPartner.vue?vue&type=script&lang=js"
export * from "./DeckCardPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports